<template>
  <div>
    <v-toolbar color="indigo" dark>
      <v-toolbar-title>
        <v-select :items="items" v-model="chartType"></v-select>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="exportExcel2">
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn>
    </v-toolbar>



    <section style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; line-height: 1.6;  border: 1px solid #e0e0e0; border-radius: 8px; background-color: #ffffff; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
  
  <h2 style="color: #3f51b5; border-bottom: 2px solid #3f51b5; padding-bottom: 8px; margin-top: 0;">📋 Dönüşüm Senaryoları ve Örnekler</h2>
  <p style="font-size: 15px; color: #555;">
    
     <v-alert type="error">
Bu özellik 22.06.2026 tarihi ile yayına alınmıştır.Aşağıdaki kurallara uyarak "Çoklu Seçenek Matrisi" özellikleri dikkate alınırsa Likert ölçeği değerlendirmesi yapılabilmektedir. 
    </v-alert>
    Fonksiyon, veri tabanından gelebilecek anket seçenek yapısına göre iki farklı strateji uygulayarak metinsel verileri istatistiksel analizlere hazır hale getirir:</p>

  <div style="margin-bottom: 30px;">
    <h3 style="color: #1a237e; font-size: 18px; margin-bottom: 10px; display: flex; align-items: center;">
      <span style="background-color: #e8eaf6; color: #3f51b5; padding: 4px 10px; border-radius: 4px; margin-right: 10px; font-size: 14px;">Senaryo 1</span> 
      Sayı ile Başlayan Seçenekler (Likert Ölçeği vb.)
    </h3>
    <p style="font-size: 14px; color: #666; margin-bottom: 12px;">Eğer anket seçenekleriniz zaten kendi içinde bir puana sahipse (Örn: <code>1 - Kesinlikle Katılmıyorum</code>), fonksiyon metnin sadece başındaki sayısal karakteri ayıklar.</p>
    
    <table style="width: 100%; border-collapse: collapse; text-align: left; font-size: 14px;">
      <thead>
        <tr style="background-color: #f5f5f5; border-bottom: 2px solid #e0e0e0;">
          <th style="padding: 10px; font-weight: 600;">Gelen Ham Metin (<code>label</code>)</th>
          <th style="padding: 10px; font-weight: 600; color: #3f51b5;">Yakalanan Değer (<code>value</code>)</th>
          <th style="padding: 10px; font-weight: 600; color: #757575;">Açıklama</th>
        </tr>
      </thead>
      <tbody>
        <tr style="border-bottom: 1px solid #eee;">
          <td style="padding: 10px;">"1 - Çok Kötü"</td>
          <td style="padding: 10px; font-weight: bold; color: #3f51b5;">1</td>
          <td style="padding: 10px; color: #757575;">Başındaki "1" karakteri algılanır.</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee; background-color: #fafafa;">
          <td style="padding: 10px;">"3 - Ne İyi Ne Kötü"</td>
          <td style="padding: 10px; font-weight: bold; color: #3f51b5;">3</td>
          <td style="padding: 10px; color: #757575;">Başındaki "3" karakteri algılanır.</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee;">
          <td style="padding: 10px;">"5 - Harika"</td>
          <td style="padding: 10px; font-weight: bold; color: #3f51b5;">5</td>
          <td style="padding: 10px; color: #757575;">Başındaki "5" karakteri algılanır.</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee; background-color: #fafafa;">
          <td style="padding: 10px;">"10 Puan"</td>
          <td style="padding: 10px; font-weight: bold; color: #3f51b5;">10</td>
          <td style="padding: 10px; color: #757575;">Başındaki "10" karakteri algılanır.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div>
    <h3 style="color: #1a237e; font-size: 18px; margin-bottom: 10px; display: flex; align-items: center;">
      <span style="background-color: #e8eaf6; color: #3f51b5; padding: 4px 10px; border-radius: 4px; margin-right: 10px; font-size: 14px;">Senaryo 2</span> 
      Tamamen Metinsel Seçenekler (Nominal / Kategorik)
    </h3>
    <p style="font-size: 14px; color: #666; margin-bottom: 12px;">Eğer seçeneklerinizin başında hiçbir sayısal ibare yoksa, sistem veri setindeki <strong>seçenek sırasını (<code>index</code>)</strong> baz alarak otomatik bir ağırlık oluşturur (<code>index + 1</code>).</p>
    
    <table style="width: 100%; border-collapse: collapse; text-align: left; font-size: 14px;">
      <thead>
        <tr style="background-color: #f5f5f5; border-bottom: 2px solid #e0e0e0;">
          <th style="padding: 10px; font-weight: 600;">Gelen Ham Metin (<code>label</code>)</th>
          <th style="padding: 10px; font-weight: 600; color: #757575;">Dizi İndeksi (<code>index</code>)</th>
          <th style="padding: 10px; font-weight: 600; color: #e91e63;">Üretilen Değer (<code>index + 1</code>)</th>
        </tr>
      </thead>
      <tbody>
        <tr style="border-bottom: 1px solid #eee;">
          <td style="padding: 10px;">"Hiç Katılmıyorum"</td>
          <td style="padding: 10px; color: #757575;">0</td>
          <td style="padding: 10px; font-weight: bold; color: #e91e63;">1</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee; background-color: #fafafa;">
          <td style="padding: 10px;">"Katılmıyorum"</td>
          <td style="padding: 10px; color: #757575;">1</td>
          <td style="padding: 10px; font-weight: bold; color: #e91e63;">2</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee;">
          <td style="padding: 10px;">"Kararsızım"</td>
          <td style="padding: 10px; color: #757575;">2</td>
          <td style="padding: 10px; font-weight: bold; color: #e91e63;">3</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee; background-color: #fafafa;">
          <td style="padding: 10px;">"Katılıyorum"</td>
          <td style="padding: 10px; color: #757575;">3</td>
          <td style="padding: 10px; font-weight: bold; color: #e91e63;">4</td>
        </tr>
        <tr style="border-bottom: 1px solid #eee;">
          <td style="padding: 10px;">"Kesinlikle Katılıyorum"</td>
          <td style="padding: 10px; color: #757575;">4</td>
          <td style="padding: 10px; font-weight: bold; color: #e91e63;">5</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="margin-top: 25px; padding: 15px; background-color: #fffde7; border-left: 4px solid #fbc02d; border-radius: 4px;">
    <h4 style="margin: 0 0 5px 0; color: #f57f17; font-size: 15px;">⚠️ Önemli Kural</h4>
    <p style="margin: 0; font-size: 13px; color: #5d4037;">
      Tamamen metinsel olan (Senaryo 2) anketlerde doğru bir Ortalama ve Medyan sonucu alabilmek için, seçeneklerin mantıksal olarak <strong>küçükten büyüğe</strong> ya da <strong>olumsuzdan olumluya</strong> doğru sıralanmış olması şarttır. Rastgele sıralamalarda indeks tabanlı ağırlıklandırma yanıltıcı sonuçlar verebilir.
    </p>
  </div>

</section>
    <div class="chartDiv">
      <div v-for="(chart, index) in lsData" :key="'chart' + index"> 
        <v-card elevation="2">
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col xs="12" sm="12" md="5" lg="5" xl="5">
                  <div class="dvTable">
                    <h3>{{ chart.header }}</h3>
   
                    <table border="1" cellpadding="5" style="border-collapse: collapse; width: 100%;">
                      <thead>
                        <tr>
                          <th>Seçenekler</th>
                          <th v-for="year in getYears(chart)" :key="year">{{ year }}</th>
                          <th>Toplam</th>
                          <th>Yüzde (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="label in getLabels(chart)" :key="'lb' + label">
                          <td>{{ label }}</td>
                          <td v-for="year in getYears(chart)" :key="year">
                            {{ buildPivot(chart)[label]?.[year] ?? 0 }}
                          </td>
                          <td>
                            {{ getLabelTotal(chart, label) }}
                          </td>
                          <td>
                            %{{ calculatePercentage(chart, label) }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>Kolon Toplamları</b></td>
                          <td v-for="year in getYears(chart)" :key="year">
                            <b>{{ buildColumnTotals(chart)[year] }}</b>
                          </td>
                          <td><b>{{ buildGrandTotal(chart) }}</b></td>
                          <td><b>%100</b></td>
                        </tr>
                        <tr style="background-color: #f5f5f5;">
                          <td><b>Aritmetik Ortalama</b></td>
                          <td colspan="3" style="text-align: center;"><b>{{ calculateMean(chart) }}</b></td>
                        </tr>
                        <tr style="background-color: #f5f5f5;">
                          <td><b>Mod (En Çok Tekrar Eden)</b></td>
                          <td colspan="3" style="text-align: center;"><b>{{ calculateMode(chart) }}</b></td>
                        </tr>
                        <tr style="background-color: #f5f5f5;">
                          <td><b>Medyan (Ortanca)</b></td>
                          <td colspan="3" style="text-align: center;"><b>{{ calculateMedian(chart) }}</b></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </v-col>
                
                <v-col cols="7">
                  <v-row>
                    <v-col v-for="(itemValue, idx) in chart.items" :key="'pchart_' + idx" cols="12" sm="6">
                      <PlotlyChart :data="itemValue.datas" :labels="itemValue.labels" :title="`${itemValue.year}`" :type="chartType">
                      </PlotlyChart> 
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
            <v-divider></v-divider>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import PlotlyChart from "@/components/PlotlyChart.vue";
import FormService from "@/services/FormService";
import Plotly from "plotly.js-dist";
import { tableToExcel } from '@/plugins/custom';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export default {
  name: "anketRapor",
  components: { PlotlyChart },
  data() {
    return {
      lsData: [],
      chartType: "bar", 
      items: ['line', 'bar', 'pie', 'donut'],
    };
  },
  mounted() {
    this.databind();
  },
  computed: {
    resimGenisligi(){
      if (this.chartType=='pie' || this.chartType=='donut' ) {
        return { width: 650, height: 350 };
      } else {
        return { width: 500, height: 280 };
      }
    }
  },
  methods: {
    async exportExcel2() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Anket Rapor");

      let currentRow = 1;
      const allPlots = document.querySelectorAll(".js-plotly-plot");
      let globalPlotIndex = 0;

      for (let i = 0; i < this.lsData.length; i++) {
        const chart = this.lsData[i];
        const sectionStartRow = currentRow; 

        // Başlık
        worksheet.getCell(`A${currentRow}`).value = chart.header;
        worksheet.getCell(`A${currentRow}`).font = { bold: true, size: 14 };
        currentRow += 2;

        // TABLO BAŞLIĞI (Yüzde Kolonu Eklendi)
        const years = this.getYears(chart);
        const labels = this.getLabels(chart);
        const pivot = this.buildPivot(chart);

        worksheet.addRow(["Seçenekler", ...years, "Toplam", "Yüzde (%)"]);
        currentRow++;

        labels.forEach(label => {
          const row = [label];
          years.forEach(year => {
            row.push(pivot[label]?.[year] ?? 0);
          });

          const total = this.getLabelTotal(chart, label);
          row.push(total);
          row.push(`%${this.calculatePercentage(chart, label)}`);

          worksheet.addRow(row);
          currentRow++;
        });

        // Kolon Toplamları satırı Excel'e yazılıyor
        const colTotals = this.buildColumnTotals(chart);
        const grandTotal = this.buildGrandTotal(chart);
        worksheet.addRow([
          "Kolon Toplamları",
          ...years.map(y => colTotals[y]),
          grandTotal,
          "%100"
        ]);
        currentRow++;

        // İSTATİSTİKLER EXCEL'E EKLENİYOR
        worksheet.addRow(["Aritmetik Ortalama", this.calculateMean(chart)]);
        worksheet.mergeCells(`B${currentRow}:D${currentRow}`);
        currentRow++;

        worksheet.addRow(["Mod (En Çok Tekrar Eden)", this.calculateMode(chart)]);
        worksheet.mergeCells(`B${currentRow}:D${currentRow}`);
        currentRow++;

        worksheet.addRow(["Medyan (Ortanca)", this.calculateMedian(chart)]);
        worksheet.mergeCells(`B${currentRow}:D${currentRow}`);
        currentRow++;

        const tableEndRow = currentRow;
        currentRow += 2;

        // GRAFİKLERİ SAĞ TARAFA KOY
        let graphRow = sectionStartRow + 1;

        for (let j = 0; j < chart.items.length; j++) {
          const plotDiv = allPlots[globalPlotIndex];

          if (plotDiv) {
            try {
              const imgData = await Plotly.toImage(plotDiv, {
                format: "png",
                width: 700,
                height: 350
              });

              const imageId = workbook.addImage({
                base64: imgData,
                extension: "png"
              });

              worksheet.addImage(imageId, {
                tl: { col: 9, row: graphRow-1 }, // I sütunu (Tablo genişlediği için sağa kaydırıldı)
                ext: this.resimGenisligi
              });

              graphRow += 16;
            } catch (err) {
              console.error(err);
            }
          }
          globalPlotIndex++;
        }

        currentRow = Math.max(currentRow, graphRow, tableEndRow + 5);
      }

      worksheet.columns = [
        { width: 25 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 5 },  
        { width: 20 }
      ];

      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }),
        "anket-rapor.xlsx"
      );
    },

    getYears(group) {
      const years = new Set();
      group.items.forEach(item => years.add(item.year));
      return Array.from(years).map(y => y.toString()).sort();
    },

    getLabels(group) {
      const labels = new Set();
      group.items.forEach(item => {
        item.labels.forEach(l => {
          if (l && l !== "undefined") labels.add(l);
        });
      });
      return Array.from(labels);
    },

    buildPivot(group) {
      const result = {};
      group.items.forEach(item => {
        item.labels.forEach((label, idx) => {
          if (label && label !== "undefined") {
            if (!result[label]) result[label] = {};
            result[label][item.year] = (result[label][item.year] || 0) + item.datas[idx];
          }
        });
      });
      return result;
    },

    buildColumnTotals(group) {
      const pivot = this.buildPivot(group);
      const years = this.getYears(group);
      const totals = {};
      years.forEach(year => {
        totals[year] = 0;
        Object.keys(pivot).forEach(label => {
          totals[year] += pivot[label][year] || 0;
        });
      });
      return totals;
    },

    buildGrandTotal(group) {
      const colTotals = this.buildColumnTotals(group);
      return Object.values(colTotals).reduce((sum, v) => sum + v, 0);
    },

    // --- YENİ EKLENEN YARDIMCI VE İSTATİSTİKSEL METOTLAR ---

    getLabelTotal(chart, label) {
      const pivot = this.buildPivot(chart);
      return Object.values(pivot[label] || {}).reduce((s, v) => s + v, 0);
    },

    calculatePercentage(chart, label) {
      const grandTotal = this.buildGrandTotal(chart);
      if (grandTotal === 0) return 0;
      const labelTotal = this.getLabelTotal(chart, label);
      return ((labelTotal / grandTotal) * 100).toFixed(1);
    },

    // Seçenek metnini sayıya dönüştürme (Örn: "5 - Çok İyi" -> 5 veya "Katılıyorum" -> index değeri)
    getNumericValue(label, index) {
      const match = label.match(/^(\d+)/);
      if (match) return parseFloat(match[1]);
      return index + 1; // Eğer string ise 1, 2, 3 diye index atar.
    },

    calculateMean(chart) {
      const labels = this.getLabels(chart);
      let totalScore = 0;
      let totalCount = 0;

      labels.forEach((label, idx) => {
        const count = this.getLabelTotal(chart, label);
        const value = this.getNumericValue(label, idx);
        totalScore += count * value;
        totalCount += count;
      });

      return totalCount > 0 ? (totalScore / totalCount).toFixed(2) : 0;
    },

    calculateMode(chart) {
      const labels = this.getLabels(chart);
      let maxCount = -1;
      let modes = [];

      labels.forEach(label => {
        const count = this.getLabelTotal(chart, label);
        if (count > maxCount) {
          maxCount = count;
          modes = [label];
        } else if (count === maxCount && count > 0) {
          modes.push(label);
        }
      });

      return maxCount > 0 ? modes.join(', ') : '-';
    },

    calculateMedian(chart) {
      const labels = this.getLabels(chart);
      const grandTotal = this.buildGrandTotal(chart);
      if (grandTotal === 0) return '-';

      // Tüm oyları sıralı bir dizi halinde simüle edelim
      let valueMap = labels.map((label, idx) => ({
        label: label,
        value: this.getNumericValue(label, idx),
        count: this.getLabelTotal(chart, label)
      }));

      // Değerlere göre küçükten büyüğe sırala
      valueMap.sort((a, b) => a.value - b.value);

      const mid = Math.floor(grandTotal / 2);
      let currentCount = 0;
      let medianLabel = '-';

      for (let i = 0; i < valueMap.length; i++) {
        currentCount += valueMap[i].count;
        if (currentCount >= mid) {
          medianLabel = valueMap[i].label;
          break;
        }
      }
      return medianLabel;
    },

    exportExcel() {
      let outTable = document.getElementsByClassName("dvTable");
      var innerDiv = document.createElement('div');
      innerDiv.className = 'block-2';
      for (let i = 0; i < outTable.length; i++) {
        innerDiv.appendChild(outTable[i].cloneNode(true));
      }
      tableToExcel(innerDiv, "anket_raporu");
    },
    
    databind() {
      FormService.anketRapor(this.$route.params.id).then((result) => {
        this.lsData = result.data;
      }).catch((err) => {
        console.error(err);
      });
    },
  },
};
</script>

<style scoped>
.chart-container {
  max-width: 1000px;
  margin: auto;
  text-align: center;
}
select {
  padding: 6px 10px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;
}
table, td, th {
  border: 1px solid #ddd;
  text-align: left;
}
table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  padding: 10px;
}
.chartDiv {
  overflow-y: scroll;
  height: calc(100vh - 165px);
}
</style>